<template>
    <div class="main">
        <report-top>
        </report-top>
        <Table border :columns="columns" :data="tableData" no-data-text="<div class='table-no-data'></div>"
            :height="utils.setTableHeight(200)">

            <Tag slot-scope="{ row, index }" slot="type" :color="midea[row.type].color">{{
                midea[row.type].name
                }}</Tag>
            <template slot-scope="{ row, index }" slot="action">
                <Button type="primary" size="small" @click="play(row)">{{ midea[row.type].btn }}</Button>
                <Button size="small" @click="makeCode(row)">手机观看</Button>
            </template>
        </Table>
        <Modal title="手机扫码查看" width="230" footer-hide v-model="openForm">
            <div id="phoneCode"></div>
        </Modal>
    </div>
</template>
<script>
var categorys = [];
export default {
    data() {
        return {
            openForm: false,
            tableData: [
                {
                    size: 12,
                    title: "平台操作说明书",
                    type: 2,
                    link: "https://cloud.ly-gps.com/files/ly-cloud/media/caozuoshuoming.pdf",
                },
                {
                    size: 12,
                    title: "运用轨迹分析问题",
                    type: 0,
                    link: "https://cloud.ly-gps.com/files/ly-cloud/media/guijifenxi.mp4",
                },
                {
                    title: "角色权限的配置",
                    type: 0,
                    link: "https://cloud.ly-gps.com/files/ly-cloud/media/juesepeizhi.mp4",
                },
                {
                    size: 12,
                    title: "车辆调度演示",
                    type: 0,
                    link: "https://cloud.ly-gps.com/files/ly-cloud/media/diaodu.mp4",
                },
                {
                    title: "司机接单演示",
                    type: 0,
                    link: "https://cloud.ly-gps.com/files/ly-cloud/media/sijijiedan.mp4",
                },
                {
                    size: 12,
                    title: "平台操作说明书",
                    type: 3,
                    link: "https://cloud.ly-gps.com/files/ly-cloud/media/来源GPS云计算平台介绍.docx",
                },
            ],
            columns: [
                {
                    type: "index",
                    width: 70,
                    align: "center",
                    sort: 0,
                },
                {
                    title: "名称",
                    key: "title",
                    
                },
                {
                    title: "格式",
                    slot: "type",
                    
                },
                {
                    title: "操作",
                    slot: "action",
                    sort: 200,
                    align: "center",
                    fixed: "right",
                },
            ],
            midea: {
                0: { name: "视频", color: "#25d37c", btn: "播放" },
                1: { name: "图文", color: "#FFA2D3", btn: "查看" },
                2: { name: "PDF", color: "#eb7881", btn: "查看" },
                3: { name: "word", color: "#34a4f8", btn: "下载" },
                4: { name: "excel", color: "#bd71d5", btn: "下载" },
            },
        };
    },
    methods: {
        makeCode(item) {
            this.openForm = true;

            var divobj = document.getElementById("phoneCode");
            divobj.innerHTML = "";
            divobj.title = "";
            new QRCode(document.getElementById("phoneCode"), {
                text: item.link,
                //logo:document.getElementById("a333"),
                width: 200,
                height: 200,
                colorDark: "#333",
                colorLight: "#fff",
                correctLevel: QRCode.CorrectLevel.H,
            });
        },
        play(item) {
            window.open(item.link);
            /* if (item.type == 0) {
              this.openForm = true;
            } else {
              this.$Message.info("待开发");
            } */
        },
    },
    mounted() {

    },
};
</script>
<style></style>


// WEBPACK FOOTER //
// src/components/system/ziyuan.vue